import React from 'react'
import { FaExclamationTriangle } from 'react-icons/fa'

import { PageMenu } from '../../../../components'
import * as colors from '../../../../assets/js/colors'

export default function SistemaMenu() {
  const menuItems = [
    { menu: 'S.0 - Permissões', path: '/main/sistema/permissoes' },
    { menu: 'S.1 - Gestão de Grupos de Usuários', path: '/main/sistema/grupo-usuario' },
    {
      menu: 'S.2 - Permissão por Grupos de Usuários',
      path: '/main/sistema/permissoes-grupo-usuario',
    },
    { menu: 'S.3 - Gestão de Usuários', path: '/main/sistema/usuario' },
    { menu: 'S.4 - Gestão de Empresas', path: '/main/sistema/empresa' },
    { menu: 'S.5 - Operadores Logísticos', path: '/main/sistema/tp' },
    { menu: 'S.6 - Central de Operações', path: '/main/sistema/central-operacoes' },
    {
      menu: 'S.7 - Importação de Clientes em Massa',
      path: '/main/sistema/importacao-clientes-em-massa',
    },
    {
      menu: 'S.8 - Importação de Produtos em Massa',
      path: '/main/sistema/importacao-produtos-em-massa',
    },
    {
      menu: 'S.9 - Importação de Assoc. Cliente x Trecho',
      path: '/main/sistema/importacao-trechos-em-massa',
    },
    {
      menu: 'S.10 - Importação de Assoc. Cliente x Empresa',
      path: '/main/sistema/importacao-assoc-cliente-empresa',
    },
    { menu: 'S.11 - Celular - Aplicativo Expedição', path: '/main/sistema/celular-app-expedicao' },
    {
      menu: 'S.12 - Tipos de Arquivo de Importação',
      path: '/main/sistema/tipos-arquivos-importacao',
    },
    { menu: 'S.13 - Gerar Arquivo Separação', path: '/main/sistema/gerar-arquivo-separacao' },
    {
      menu: 'S.14 - Operações Movimentação Insumo',
      path: '/main/sistema/operacoes-movimentacao-insumo',
    },
    { menu: 'S.15 - Patrimônio Owner', path: '/main/sistema/patrimonio-owner' },
    { menu: 'S.16 - Grupo de Empresas', path: '/main/sistema/company-group' },
    {
      menu: 'S.17 - Importação de Produtos EAN em Massa',
      path: '/main/sistema/importacao-produtos-ean-em-massa',
    },
    {
      menu: 'S.18 - Alterar Codigo do Identificador da Delivery',
      path: '/main/sistema/alterar-identificador-delivery',
    },
    { menu: 'S.19 - Configurações de Usuarios', path: '/main/sistema/configuracoes-usuarios' },
    {
      menu: 'S.20 - Clientes com Inconsistencia de Endereço',
      path: '/main/sistema/clientes-inconsistentes',
    },

    {
      menu: 'S.21 - Importação de Motoristas em Massa',
      path: '/main/sistema/importacao-motoristas-em-massa',
    },
    {
      menu: 'S.22 - Importação de Veículos em Massa',
      path: '/main/sistema/importacao-veiculo-em-massa',
    },
    {
      menu: 'S.23 - Gestão de Emissores de CTe',
      path: '/main/sistema/emissor-cte',
    },
    {
      menu: 'S.24 - Gestão de CFOPs',
      path: '/main/sistema/cfop',
    },
    {
      menu: 'S.25 - Importação de Vínculo Rota/Cliente em Massa',
      path: '/main/sistema/import-vinculo-rota-cliente-massa',
    },
    {
      menu: 'S.26 - Celulares - Aplicativo Tp Drive',
      path: '/main/sistema/celular-app-tp-drive',
    },
    {
      menu: 'S.27 - Ocorrências Padrões',
      path: '/main/sistema/ocorriencia-padrao-empresa',
    },
    {
      menu: 'S.28 - Grau de Utilização do Sistema',
      path: '/main/sistema/monitoramento-grau-utilizacao',
    },
    {
      menu: 'S.29 - Alterar status de um picking',
      path: '/main/sistema/alterar-status-picking',
    },
    {
      menu: 'S.30 - Empresas X Central de Operações',
      path: '/main/sistema/empresas-central-operacoes',
    },
    {
      menu: 'S.31 - Saldo Movimentações x Saldo Estoque',
      path: '/main/sistema/saldo-movimentacoes-saldo-estoque',
    },
    {
      menu: 'S.32 - Configurações do Robô de leitura de XML',
      path: '/main/sistema/configuracoes-robo-xml',
    },
    {
      menu: 'S.33 - Cadastrar Vídeos de Treinamento',
      path: '/main/sistema/treinamentos',
    },
  ]
  return (
    <PageMenu icon={<FaExclamationTriangle color={colors.azul} size="24" />} menuItems={menuItems}>
      Sistema
    </PageMenu>
  )
}
